import {
  EventDateDisplay,
  EventNameDisplay,
  VenueNameDisplay,
} from 'src/components/Events/EventInfo';
import * as PosCollapsible from 'src/core/POS/PosCollapsible';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import {
  getDescription,
  getEventPerformerVenue,
} from 'src/utils/eventWithDataUtils';
import { CatalogResults } from 'src/WebApiController';

import * as styles from '../../../modals/SponsoredListings/CampaignModal/CampaignModal.css';
import * as boostActionsStyles from './BulkBoostEventsDialog.css';

export const EventAccordionSection = ({
  label,
  events,
  isOpen,
  onToggle,
  data,
}: {
  label: string;
  events: string[];
  isOpen: boolean;
  onToggle: () => void;
  data?: CatalogResults | null;
}) => {
  return (
    <div
      className={`${styles.subsectionContainer} ${boostActionsStyles.accordionSectionContainer}`}
    >
      <PosCollapsible.Root
        open={isOpen}
        onOpenChange={onToggle}
        className={boostActionsStyles.accordionRoot}
      >
        <PosCollapsible.Trigger
          className={boostActionsStyles.accordionTrigger}
          iconClassName={boostActionsStyles.eventAccordionTriggerIcon}
          iconSize={vars.iconSize.s}
        >
          <span className={boostActionsStyles.accordionLabel}>{label}</span>
        </PosCollapsible.Trigger>
        <PosCollapsible.Content className={boostActionsStyles.accordionContent}>
          <div className={boostActionsStyles.accordionContentScroll}>
            <div className={boostActionsStyles.accordionContentInner}>
              {events.map((virtId) => (
                <EventPillItem key={virtId} virtId={virtId} data={data} />
              ))}
            </div>
          </div>
        </PosCollapsible.Content>
      </PosCollapsible.Root>
    </div>
  );
};

const EventPillItem = ({
  virtId,
  data,
}: {
  virtId: string;
  data?: CatalogResults | null;
}) => {
  const eventWithData = data?.events?.[virtId];
  const event = eventWithData?.event;
  if (!event) return null;

  const { venue } = getEventPerformerVenue(virtId, data);

  let eventName = event.name ?? '';
  let eventSubName = '';
  const lastIndex = eventName.lastIndexOf(' - ');
  if (lastIndex > 0) {
    eventSubName = eventName.slice(lastIndex + 3);
    eventName = eventName.slice(0, lastIndex);
  }

  const subnameIsVenue =
    venue?.name &&
    eventSubName.toLocaleLowerCase().includes(venue.name.toLocaleLowerCase());

  return (
    <div className={boostActionsStyles.eventItemContainer}>
      <Stack direction="column" alignItems="start" gap="s" width="full">
        <EventNameDisplay
          eventName={eventName}
          eventNameConnector={
            subnameIsVenue || !eventSubName ? undefined : ' - '
          }
          eventSubName={subnameIsVenue ? undefined : eventSubName}
          slimContent
        />
        <Stack gap="m" alignItems="center" flexWrap="noWrap" width="full">
          <VenueNameDisplay
            venueName={venue?.name}
            venueLocation={getDescription(venue)}
            hideIcon
            className={boostActionsStyles.venueDateContainer}
            displayClassName={boostActionsStyles.venueDateDisplay}
          />
          <span className={boostActionsStyles.eventDivider}>|</span>
          <EventDateDisplay
            eventDateString={event.dates?.start ?? undefined}
            eventEndDateString={event.dates?.end ?? undefined}
            eventDateFormat="MMM d, y"
            dateTimeSeparator="@"
            showEventDateTbd
            hideIcon
            className={boostActionsStyles.venueDateContainer}
            displayClassName={boostActionsStyles.venueDateDisplay}
          />
        </Stack>
      </Stack>
    </div>
  );
};
